import { useOutletContext } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';

import styles from './../../content/ContentContainer.module.css';

const ContentById = () => {
    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    var {contentId} = useParams();
    const {lang} = useOutletContext();

    const [content, setContent] = useState({title: '', contents: []});

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const response = await fetch(`${API_URL}/common/get_content_by_id.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({content_id: contentId})
                });
                const data = await response.json();
                setContent(data);
            } catch (error) {
                console.error('Error fetching content:', error);
            }
        };

        if (!contentId) {
            contentId = 10113;
        }
        fetchContent();
    }, [contentId, lang]);

    return (
            <>            
            
            <div className="mbkegy-content" dangerouslySetInnerHTML={{__html: content.contents.length === 1 ? content.contents[0].header : ''}} />
            <h1 className="mbkegy-content"  dangerouslySetInnerHTML={{__html: content.title}} />
            {content.contents.length < 2 ? (
                            <>
                            <div className="mbkegy-content" dangerouslySetInnerHTML={{__html: content.contents.length === 1 ? content.contents[0].text : ''}} />
                            </>
                        ) : (
                            <div  className="carousel-container">
                                <Carousel>
                                    {content.contents.map((item) => (
                                                            <Carousel.Item key={item.id}>
                                                                <div className="mbkegy-content" dangerouslySetInnerHTML={{__html: item.header}} />
                                                                <h2 className="mbkegy-content" dangerouslySetInnerHTML={{__html: item.title}} />
                                                                <div className="mbkegy-content" dangerouslySetInnerHTML={{__html: item.text}} />
                                                            </Carousel.Item>
                                                            ))}
                                </Carousel>
                            </div>)}
            </>
            );
};

export default ContentById;
